import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import { GlobalActions, ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasThhPferdData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasThhPferdDataForShop } from './transformer/thhPferdData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasThhPferdData
>(App.THH_PFERD);
export const shopTarifierer = new ShopTarifierer({
  appId: App.THH_PFERD,
  taasDataBuilder: buildTaasThhPferdDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungThhPferd(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_THH_PFERD,
    safeSaga(shopTarifierer.handleSuccess, App.THH_PFERD),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(shopTarifierer.callTarifierung, App.THH_PFERD),
  );
}
